<template>
	<div class="ProductFollowSale">
		<el-form
			class="custom-formScreen"
			label-width="93px"
			inline
			ref="formScreen"
			:model="formScreen"
		>
			<el-form-item label="选择店铺">
				<el-select
					v-model="shopItem"
					value-key="shopId"
					@change="searchForm"
				>
					<el-option
						v-for="item in listShop"
						:key="item.shopId"
						:label="item.shopName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="跟卖状态" prop="status">
				<el-select v-model="formScreen.status">
					<el-option
						v-for="(item, key) in followSaleStatus"
						:key="key"
						:label="item.label"
						:value="key"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label=" " style="width: 40%;" prop="str">
				<el-input
					placeholder="SKU/ASIN"
					style="width: calc(100% - 140px);margin-right: 10px;"
					v-model="formScreen.str"
				></el-input>
				<el-button type="primary" @click="searchForm">搜索</el-button>
				<el-button type="primary" @click="resetForm">重置</el-button>
			</el-form-item>
		</el-form>

		<el-row style="margin-bottom: 20px;">
			<el-row type="flex" justify="space-between" align="middle">
				<div>
					<el-button type="primary" @click="IncreaseProduct"
						>添加跟卖产品</el-button
					>
					<!--        <el-button type="primary" @click="PriceRule">调价规则</el-button>-->
					<!--          <el-button type="primary" @click="ShelfTime">上下架时间</el-button>-->
					<el-button type="primary" @click="deleteProduct"
						>删除跟卖</el-button
					>
					<el-button type="primary" @click="downloadExcel"
						>导出Excel</el-button
					>
					<el-button type="primary" @click="followSaleVisible = true"
						>查看跟卖方法</el-button
					>
				</div>
				<div>
					<el-button type="primary" @click="ShelfTime"
						>上传</el-button
					>
				</div>
			</el-row>
		</el-row>

		<el-table
			:data="listTableManage"
			border
			:header-cell-style="{ textAlign: 'center' }"
			v-loading="loadingManage"
			@selection-change="handleTableSelect"
		>
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column
				prop="asin"
				label="ASIN"
				width="200"
				align="center"
			></el-table-column>
			<el-table-column
				prop="sku"
				label="SKU"
				width="200"
				align="center"
			></el-table-column>
			<el-table-column label="最大/小价" width="160" align="center">
				<template slot-scope="scope">
					<div>
						{{ `${scope.row.maxPrice}/${scope.row.minPrice}` }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="price"
				label="价格"
				width="140"
				align="center"
			></el-table-column>
			<el-table-column
				prop="stock"
				label="库存"
				width="140"
				align="center"
			></el-table-column>
			<el-table-column
				prop="sourceLink"
				label="货源"
				width="100"
				align="center"
			>
				<template slot-scope="scope">
					<template v-if="scope.row.sourceLink">
						<el-link
							:href="scope.row.sourceLink"
							target="_blank"
							type="primary"
							>BUY</el-link
						>
					</template>
					<template v-else>
						<div>暂无</div>
					</template>
				</template>
			</el-table-column>
			<el-table-column label="跟卖状态" align="center" width="160">
				<template slot-scope="scope">
					<div
						:style="{
							color: followSaleStatus[scope.row.status].color,
						}"
					>
						{{ followSaleStatus[scope.row.status].label }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="priceRules"
				label="调价规则"
				align="center"
			></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-row type="flex" justify="center">
						<el-button type="primary" @click="modifyInfo(scope.row)"
							>编辑</el-button
						>
						<el-button
							type="warning"
							icon="el-icon-document"
							@click="resultVisible(scope.row)"
						></el-button>
					</el-row>
				</template> 
			</el-table-column>
		</el-table>

		<el-row
			class="pagination-box"
			type="flex"
			justify="center"
			align="middle"
		>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page"
				:page-sizes="[10, 30, 50, 70, 90, 100]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</el-row>

		<el-dialog
			title="编辑跟卖信息"
			width="600px"
			:visible.sync="dialogVisible"
			top="4vh"
			append-to-body
		>
			<el-form
				label-width="100px"
				ref="dialogForm"
				:model="dialogForm"
				:rules="dialogFormRules"
			>
				<el-form-item label="ASIN" prop="asin">
					<el-input v-model="dialogForm.asin"></el-input>
				</el-form-item>
				<el-form-item label="SKU" prop="sku">
					<el-input v-model="dialogForm.sku"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input v-model="dialogForm.price"></el-input>
				</el-form-item>
				<el-form-item label="最大价格" prop="maxPrice">
					<el-input v-model="dialogForm.maxPrice"></el-input>
				</el-form-item>
				<el-form-item label="最小价格" prop="minPrice">
					<el-input v-model="dialogForm.minPrice"></el-input>
				</el-form-item>
				<el-form-item label="库存" prop="stock">
					<el-input v-model="dialogForm.stock"></el-input>
				</el-form-item>
				<el-form-item label="来源链接" prop="sourceLink">
					<el-input v-model="dialogForm.sourceLink"></el-input>
				</el-form-item>
				<el-form-item label="调价规则" prop="priceRules">
					<el-input v-model="dialogForm.priceRules"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button
					type="primary"
					@click="submitUpdate"
					v-loading="loadingDialogModify"
					>提 交</el-button
				>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="followSaleVisible" top="4vh" width="1000px">
			<div v-html="followSaleStr"></div>
		</el-dialog>

		<el-dialog
            class="custom-dialog"
			title="跟卖结果"
			:visible.sync="resultDialogVisible"
			width="50%"
            :close-on-click-modal="false"
            top="4vh">
            <div v-for="(item, key) in resultData.handleUploadResult" :key="key">
                <template v-if="key !== 'totalResult' && item.result !== 'success'">
                    <div style="font-size:24px;">{{ `${key} - ${item.result}` }}</div>
                    <template v-for="(value, k, i) in item">
                        <div v-if="k !== 'result'" :key="i" style="padding:5px 0;">
                            <span :style="{ color: k.includes('Warning') ? '#ebb563' : 'red' }">{{ k }}：</span>
                            <span>{{ value }}</span>
                        </div>
                    </template>
                </template>
            </div>
            <template v-if="resultData.handleTranslateUploadResult">
                <el-divider content-position="left">翻译结果</el-divider>
                <div v-for="(item, key) in resultData.handleTranslateUploadResult" :key="key">
                    <template v-if="item.结果 !== '成功'">
                        <div style="font-size:24px;">{{ `${key} - ${item.结果}` }}</div>
                        <template v-for="(value, k, i) in item">
                            <div v-if="k !== '结果'" :key="i" style="padding:5px 0;">
                                <span :style="{ color: k.includes('警告') ? '#ebb563' : 'red' }">{{ k }}：</span>
                                <span>{{ value }}</span>
                            </div>
                        </template>
                    </template>
                </div>
            </template>
			<div slot="footer">
				<el-button type="primary" @click="resultDialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>

		<increase-product ref="IncreaseProduct" @confirm="submitIncrease" />
		<!--    <price-rule ref="PriceRule"/>-->
		<shelf-time ref="ShelfTime" @confirm="uploadFollowSale" />
		<!--    <delete-product ref="DeleteProduct"/>-->
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
import IncreaseProduct from './followSaleComponents/increaseProduct'
import ShelfTime from './followSaleComponents/shelfTime'
import FollowSaleStr from './FollowSaleMethod.js'

export default {
	name: 'ProductFollowSale',
	components: {
		IncreaseProduct,
		ShelfTime,
	},
	data() {
		return {
			UserInfo: {},
			page: 1,
			size: 10,
			total: 0,
			formScreen: {
				status: '',
				str: '',
			},
			listTableManage: [],
			loadingManage: false,
			listTableMonitor: [],
			resultDialogVisible: false,
            resultData: {},

			shopItem: null,
			listShop: [],
			strASIN: '',
			strSKU: '',
			followSaleStatus: {
				1: { color: 'red', label: '未跟卖' },
				2: { color: 'green', label: '已跟卖' },
			},
			dialogVisible: false,
			dialogForm: {},
			dialogFormRules: {
				asin: [
					{
						required: true,
						message: '请输入ASIN码',
						trigger: 'blur',
					},
				],
				sku: [
					{ required: true, message: '请输入SKU码', trigger: 'blur' },
				],
				price: [
					{ required: true, message: '请输入价格', trigger: 'blur' },
				],
				maxPrice: [
					{
						required: true,
						message: '请输入最大价格',
						trigger: 'blur',
					},
				],
				minPrice: [
					{
						required: true,
						message: '请输入最小价格',
						trigger: 'blur',
					},
				],
				stock: [
					{ required: true, message: '请输入库存', trigger: 'blur' },
				],
				sourceLink: [
					{
						required: true,
						message: '请输入来源链接',
						trigger: 'blur',
					},
				],
			},
			loadingDialogModify: false,
			formTime: {},
			checkedIds: [],
			followSaleStr: FollowSaleStr,
			followSaleVisible: false,
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.getListShop()
		// this.getTime()
	},
	methods: {
		resultVisible(item) {
			this.resultDialogVisible = true;
			this.resultData = item;
			console.log(this.resultData)
		},
		handleSizeChange(val) {
			this.size = val
			this.getListTableManage()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getListTableManage()
		},
		searchForm() {
			this.page = 1
			this.getListTableManage()
		},
		resetForm() {
			this.shopItem = this.listShop[0]
			this.$refs.formScreen.resetFields()
			this.searchForm()
		},
		handleTableSelect(selection) {
			this.checkedIds = selection
		},
		IncreaseProduct() {
			this.$refs.IncreaseProduct.openDialog()
		},
		ShelfTime() {
			if (this.checkedIds.map((item) => item.id) == '') {
				this.$confirm('请至少选择一个', '提示')
			} else {
				this.$refs.ShelfTime.openDialog()
			}
		},
		getListShop() {
			const API = Baseurl + 'sellerController/selectMyFineShopByRid'
			const paramsData = {
				rid: this.UserInfo.rid,
				system: this.UserInfo.system,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					if (!data.length) return
					const temporaryArr = data.reduce(
						(prevVal, item) => [
							...prevVal,
							...item.countryMarks.map((key) => {
								key.mwsAuthToken = item.mwsAuthToken
								key.sellerId = item.sellerId
								return key
							}),
						],
						[]
					)

					this.listShop = temporaryArr
					this.shopItem = this.listShop[0]

					this.getListTableManage()
				}
			})
		},
		submitIncrease(tableData) {
			const API = Baseurl + 'productSaleController/batchAdd'
			const paramsData = {
				rid: this.UserInfo.rid,
				marketInfo: {
					sellerId: this.shopItem.sellerId,
					mwsToken: this.shopItem.mwsAuthToken,
					countryMark: this.shopItem.countryMark,
					marketPlaceId: this.shopItem.marketPlaceId,
				},
				productSale: tableData,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.searchForm()
					this.$refs.IncreaseProduct.closeDialog()
					this.$message.success(data)
				} else {
					this.$message.error(data)
				}
			})
		},
		getListTableManage() {
			const API =
				Baseurl + 'productSaleController/selectBySellerIdAndCountryMark'
			const paramsData = {
				page: this.page,
				size: this.size,
				sellerId: this.shopItem.sellerId,
				countryMark: this.shopItem.countryMark,
				...this.formScreen,
			}
			this.loadingManage = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingManage = false
				const { code, data } = res.data
				if (code === 200) {
					if(data.list !== '') {
						this.total = data.total
						data.list.forEach(item => {
							if(item.saleResult) {
								const handleData = (item.handleUploadResult = {
									productInfo: JSON.parse(item.saleResult)
									});
								for(const key in handleData) {
									handleData.totalResult = handleData[key].result;
									if(handleData.totalResult !== "success") {
										break;
									}
								}
							}
						});
						this.listTableManage = data.list
					}
				}
			})
		},
		modifyInfo(row) {
			this.dialogVisible = true
			this.dialogForm = JSON.parse(JSON.stringify(row))
		},
		submitUpdate() {
			this.$refs.dialogForm.validate((valid) => {
				if (!valid) return
				const API = Baseurl + 'productSaleController/update'
				const paramsData = this.dialogForm
				this.loadingDialogModify = true
				ajaxPost(API, paramsData).then((res) => {
					this.loadingDialogModify = false
					const { code, data } = res.data
					if (code === 200) {
						this.dialogVisible = false
						this.getListTableManage()
						this.$message.success('操作成功')
					} else {
						this.$message.error(data || '操作失败')
					}
				})
			})
		},
		uploadFollowSale(timeData) {
			this.$confirm('确定要进行跟卖吗？', '提示')
				.then(() => {
					const API = Baseurl + 'amaoznFeedUpload/insertProductSale'
					const paramsData = {
						rid: this.UserInfo.rid,
						marketInfo: {
							sellerId: this.shopItem.sellerId,
							mwsAuthToken: this.shopItem.mwsAuthToken,
							countryMark: this.shopItem.countryMark,
							marketplaceId: this.shopItem.marketPlaceId,
							...timeData,
						},
						ids: this.checkedIds.map((item) => item.id),
					}
					ajaxPost(API, paramsData).then((res) => {
						const { code, data } = res.data
						if (code === 200) {
							this.$refs.ShelfTime.closeDialog()
							this.getListTableManage()
							this.$message.success(data || '操作成功')
						} else {
							this.$message.error(data || '操作有误')
						}
					})
				})
				.catch(() => {})
		},
		submitTime(data) {
			const API = Baseurl + 'productSaleTimeController/insert'
			const paramsData = {
				rid: this.UserInfo.rid,
				...data,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.$refs.ShelfTime.closeDialog()
					this.$message.success(data || '操作成功')
				} else {
					this.$message.error(data || '操作失败')
				}
			})
		},
		deleteProduct() {
			if (!this.checkedIds.length) {
				this.$message.warning('请先选中需要删除的产品！')
				return
			}
			this.$confirm('您确定要删除选中的产品吗', '提示').then(() => {
				const API = Baseurl + 'productSaleController/delete'
				const paramsData = {
					rid: this.UserInfo.rid,
					marketInfo: {
						sellerId: this.shopItem.sellerId,
						mwsAuthToken: this.shopItem.mwsAuthToken,
						countryMark: this.shopItem.countryMark,
						marketplaceId: this.shopItem.marketPlaceId,
					},
					ids: this.checkedIds.map((item) => item.id),
				}
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.getListTableManage()
						this.$message.success('操作成功')
					} else {
						this.$message.error(data || '操作成功')
					}
				})
			})
		},
		downloadExcel() {
			const API = Baseurl + 'productSaleController/exportProductSaleList'
			const paramsData = {
				sellerId: this.shopItem.sellerId,
				countryMark: this.shopItem.countryMark,
				...this.formScreen,
			}
			// ajaxPost(API, paramsData).then(res => {
			//   const blob = new Blob([res], { type: "application/vnd.ms-excel" });
			//   const fileName = '跟卖产品.xls';
			//   const aEle = document.createElement('a');
			//   aEle.download = fileName;
			//   aEle.href = URL.createObjectURL(blob);
			//   aEle.click();
			//   URL.revokeObjectURL(aEle.href); // 释放URL 对象
			// })
			const blobs = { responseType: 'arraybuffer' }
			this.$http.post(API, paramsData, blobs).then((response) => {
				const { status, data } = response
				if (status === 200) {
					const blob = new Blob([data], {
						type: 'application/vnd.ms-excel',
					})
					const fileName = `产品跟卖调价规则表-${this.shopItem.countryMark}.xls`
					const aEle = document.createElement('a')
					aEle.download = fileName
					aEle.href = URL.createObjectURL(blob)
					aEle.click()
					URL.revokeObjectURL(aEle.href) // 释放URL 对象
				}
			})
		},
		viewFollowSale() {},
	},
}
</script>

<style lang="scss" scoped>
.ProductFollowSale {
	width: 98%;
	padding-bottom: 52px;

	.pagination-box {
		width: calc(97% - 200px);
		background: #fff;
		position: fixed;
		bottom: 0;
		left: 200px;
		padding: 10px;
		z-index: 999;
	}
}
</style>
